import React from 'react'
import { Flex, Link, Heading, Text } from 'theme-ui'
import { nanoid } from 'nanoid'
import checkIfExternalLink from '../../../helpers/checkIfExternalLink'
import ImageSelector from '../../Images/ImageSelector'
import TextBodySelector from '../../General/TextBodySelector'

export default function ContentBox({
  variantName,
  poweredImages,
  locationIndex,
  image,
  ctaLink,
  title,
  text,
  textType,
  subtitle
}) {
  return (
    <Link
      key={nanoid()}
      variant={`${variantName}.box`}
      className="box"
      sx={{
        pointerEvents: ctaLink ? 'visible' : 'none' // makes the box none clickable if no link
      }}
      href={ctaLink}
      target={`${ctaLink && checkIfExternalLink(ctaLink) ? '_blank' : ''}`}
      rel={`${ctaLink && checkIfExternalLink(ctaLink) ? 'noreferrer' : ''}`}
    >
      {image && (
        <ImageSelector
          className="image"
          variant={`${variantName}.image`}
          image={image} // image from config
          poweredImages={poweredImages} // powered iamges object
          locationIndex={locationIndex}
          clickable={false}
          imageWidth={600}
        />
      )}
      {title && (
        <Heading variant={`${variantName}.title`} className="title" as="h3">
          {title}
        </Heading>
      )}
      {subtitle && (
        <Heading variant={`${variantName}.subtitle`} className="subtitle" as="h4">
          {subtitle}
        </Heading>
      )}
      {/* {text && (
        <Text variant={`${variantName}.text`} className='text' as='p'>
          {text}
        </Text>
      )} */}

      {text && <TextBodySelector variantName={`${variantName}`} texts={text} textType={textType} />}
    </Link>
  )
}
